import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch } from '../utils';

export const settingsRedirections: RedirectionStateObject = {
  'dashboard.home': () => `/360/`,
  'dashboard.settings.general': () => `/360/settings`,
  'dashboard.settings.manage-users': () => `/360/settings/users`,
  'dashboard.settings.audit-trail': () => `/360/settings/audit-trail`,
  'dashboard.settings.manage-accounts': () => `/360/settings/accounts`,
  'dashboard.tools.system-status': () => `/360/settings/system-status`,
  'dashboard.alerts.endpoints': () => `/360/settings/notification-endpoints`,
  'dashboard.settings.manage-tokens.shared': () => `/360/settings/manage-tokens/share-tokens`,
  'dashboard.settings.manage-tokens.api': () => `/360/settings/manage-tokens/api`,
  'dashboard.settings.manage-tokens.data-shipping': params =>
    `/360/settings/manage-tokens/data-shipping${tanstackUrlSearch(params)}`,
  'dashboard.settings.plan-and-billing.plan': () => `/360/settings/plan-and-billing/plan`,
  'dashboard.settings.plan-and-billing.usage': () => `/360/settings/plan-and-billing/usage`,
  'dashboard.settings.plan-and-billing.ai-settings': () => `/360/settings/plan-and-billing/ai-settings`,
};
